/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainPolicyStatus = 'Active' | 'Archived';

export const DomainPolicyStatus = {
    Active: 'Active' as DomainPolicyStatus,
    Archived: 'Archived' as DomainPolicyStatus
};